export const defaultForm = () => {
  return {
    name: "",
    description: "",
    customization: {
      company_name: "",
      meta_data: {
        primary_color: "#9e1531",
        secondary_color: "#140508"
      }
    },

    verification_type: {
      verification_type_id: 1
    },

    user_auth_types: {
      password: {
        config: {
          username_label: "Email",
          username_field_type_id: 6,
          password_label: "Password",
          password_validation: {
            min_length: 8,
            include_uppercase: true,
            include_numbers: true,
            include_special: false
          }
        }
      }
    },

    user_data_fields: [
      {
        field_type_id: 1,
        label: "",
        name: "",
        hint: "",
        is_required: true,
        selected: true,
        allow_autofill: false,
        meta_data: {}
      }
    ],

    auth: {
      allow_2fa_login: false,
      allow_2fa_signup: true
    },

    development: {
      domain: "",
      oauth: {
        redirect_uri: "",
        is_spa: true
      }
    }
  };
};
